import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const DEFAULT_COLOR = '#D2D6DB';

export const LegalAdviceIcon = ({
  className = 'h-4 w-4',
  ...props
}: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    {...props}
  >
    <path d='M12 2L2 7L12 12L22 7L12 2Z' />
    <path d='M2 17L12 22L22 17' />
    <path d='M2 12L12 17L22 12' />
  </svg>
);

export const ChatIcon = ({ className = 'h-4 w-4', ...props }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    {...props}
  >
    <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
  </svg>
);

export const EditIcon = ({ className = 'h-4 w-4', ...props }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    {...props}
  >
    <path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' />
    <path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' />
  </svg>
);

export const DeleteIcon = ({ className = 'h-4 w-4', ...props }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    {...props}
  >
    <path d='M3 6h18' />
    <path d='M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' />
  </svg>
);

export const SaveIcon = ({ className = 'h-4 w-4', ...props }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
    {...props}
  >
    <path d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z' />
    <polyline points='17 21 17 13 7 13 7 21' />
    <polyline points='7 3 7 8 15 8' />
  </svg>
);

export const VectorIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    height={height}
    width={width}
    viewBox='0 0 20 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 2.35716C0 1.97828 0.15051 1.61492 0.418419 1.34701C0.686328 1.0791 1.04969 0.928589 1.42857 0.928589H18.5714C18.9503 0.928589 19.3137 1.0791 19.5816 1.34701C19.8495 1.61492 20 1.97828 20 2.35716C20 2.73604 19.8495 3.0994 19.5816 3.36731C19.3137 3.63522 18.9503 3.78573 18.5714 3.78573H1.42857C1.04969 3.78573 0.686328 3.63522 0.418419 3.36731C0.15051 3.0994 0 2.73604 0 2.35716ZM0 9.50002C0 9.12114 0.15051 8.75777 0.418419 8.48986C0.686328 8.22196 1.04969 8.07145 1.42857 8.07145H18.5714C18.9503 8.07145 19.3137 8.22196 19.5816 8.48986C19.8495 8.75777 20 9.12114 20 9.50002C20 9.8789 19.8495 10.2423 19.5816 10.5102C19.3137 10.7781 18.9503 10.9286 18.5714 10.9286H1.42857C1.04969 10.9286 0.686328 10.7781 0.418419 10.5102C0.15051 10.2423 0 9.8789 0 9.50002ZM0 16.6429C0 16.264 0.15051 15.9006 0.418419 15.6327C0.686328 15.3648 1.04969 15.2143 1.42857 15.2143H10C10.3789 15.2143 10.7422 15.3648 11.0102 15.6327C11.2781 15.9006 11.4286 16.264 11.4286 16.6429C11.4286 17.0218 11.2781 17.3851 11.0102 17.653C10.7422 17.9209 10.3789 18.0714 10 18.0714H1.42857C1.04969 18.0714 0.686328 17.9209 0.418419 17.653C0.15051 17.3851 0 17.0218 0 16.6429Z'
        fill={color ? color : 'currentColor'}
      />
    </svg>
);

export const SendInputIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.07 8.51001L9.51002 4.23001C3.76002 1.35001 1.40002 3.71001 4.28002 9.46001L5.15002 11.2C5.15815 11.2166 5.16601 11.2333 5.17361 11.25H10.15C10.56 11.25 10.9 11.59 10.9 12C10.9 12.41 10.56 12.75 10.15 12.75H5.17812C5.16914 12.7701 5.15977 12.7901 5.15002 12.81L4.28002 14.54C1.40002 20.29 3.75002 22.65 9.51002 19.77L18.07 15.49C21.91 13.57 21.91 10.43 18.07 8.51001Z'
        fill={color ? color : 'currentColor'}
      />
    </svg>
);

export const RightArrowIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        d='M14.4301 18.819C14.3316 18.8194 14.2339 18.8001 14.1429 18.7623C14.0519 18.7245 13.9694 18.669 13.9001 18.599C13.7606 18.4579 13.6824 18.2674 13.6824 18.069C13.6824 17.8706 13.7606 17.6801 13.9001 17.539L19.4401 11.999L13.9001 6.45901C13.7703 6.31636 13.7005 6.12921 13.7051 5.93642C13.7097 5.74364 13.7884 5.56003 13.9248 5.42374C14.0612 5.28744 14.2449 5.20893 14.4377 5.20451C14.6305 5.20009 14.8175 5.27011 14.9601 5.40001L21.0301 11.47C21.1696 11.6111 21.2478 11.8016 21.2478 12C21.2478 12.1984 21.1696 12.3889 21.0301 12.53L14.9601 18.6C14.8907 18.6698 14.8081 18.7252 14.7171 18.7628C14.6261 18.8004 14.5285 18.8195 14.4301 18.819Z'
        fill={color ? color : 'currentColor'}
      />
      <path
        d='M20.33 12.75H3.5C3.30149 12.7487 3.11149 12.6693 2.97112 12.5289C2.83075 12.3885 2.75131 12.1985 2.75 12C2.75131 11.8015 2.83075 11.6115 2.97112 11.4711C3.11149 11.3307 3.30149 11.2513 3.5 11.25H20.33C20.5285 11.2513 20.7185 11.3307 20.8589 11.4711C20.9993 11.6115 21.0787 11.8015 21.08 12C21.0787 12.1985 20.9993 12.3885 20.8589 12.5289C20.7185 12.6693 20.5285 12.7487 20.33 12.75Z'
        fill={color ? color : 'currentColor'}
      />
    </svg>
);

export const RefreshIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        d='M12 22.75C10.2936 22.7497 8.61932 22.2859 7.15591 21.4083C5.69249 20.5307 4.4949 19.2721 3.69098 17.7669C2.88705 16.2617 2.50699 14.5665 2.59136 12.8622C2.67573 11.1578 3.22137 9.50843 4.17001 8.09001C4.28008 7.92425 4.45148 7.80901 4.64652 7.76962C4.84156 7.73024 5.04425 7.76995 5.21001 7.88001C5.37577 7.99008 5.49102 8.16148 5.53041 8.35652C5.56979 8.55156 5.53008 8.75425 5.42001 8.92001C4.43823 10.3888 3.9755 12.1435 4.10537 13.9055C4.23525 15.6674 4.95027 17.3353 6.13681 18.6442C7.32335 19.9532 8.91332 20.828 10.6541 21.1297C12.3948 21.4313 14.1864 21.1425 15.7442 20.3092C17.302 19.4758 18.5366 18.1457 19.2518 16.5303C19.9669 14.9148 20.1216 13.1067 19.6913 11.3932C19.261 9.67972 18.2704 8.15922 16.8768 7.07333C15.4832 5.98744 13.7667 5.39847 12 5.40001C11.0956 5.39699 10.1958 5.52843 9.33001 5.79001C9.14035 5.84401 8.93706 5.82144 8.76386 5.72717C8.59065 5.63289 8.46133 5.47443 8.40371 5.28583C8.34608 5.09723 8.36474 4.89356 8.45567 4.71857C8.54661 4.54358 8.70256 4.41125 8.89001 4.35001C9.89866 4.04564 10.9464 3.89066 12 3.89001C14.501 3.89001 16.8996 4.88353 18.668 6.652C20.4365 8.42047 21.43 10.819 21.43 13.32C21.43 15.821 20.4365 18.2196 18.668 19.988C16.8996 21.7565 14.501 22.75 12 22.75Z'
        fill={color ?? 'currentColor'}
      />
      <path
        d='M7.87 6.07C7.69056 6.06965 7.517 6.0059 7.38 5.89C7.30473 5.82593 7.2429 5.74758 7.19809 5.65947C7.15328 5.57137 7.12638 5.47525 7.11894 5.37668C7.1115 5.27812 7.12367 5.17905 7.15475 5.08522C7.18583 4.99138 7.2352 4.90464 7.3 4.83L10.19 1.51C10.2547 1.43532 10.3336 1.37422 10.422 1.33023C10.5105 1.28624 10.6068 1.26024 10.7054 1.25373C10.804 1.24722 10.9029 1.26033 10.9964 1.2923C11.0898 1.32428 11.1761 1.37448 11.25 1.44C11.3987 1.57198 11.4895 1.75723 11.5026 1.95563C11.5157 2.15404 11.4501 2.34961 11.32 2.5L8.43 5.81C8.36017 5.89025 8.2742 5.95489 8.17771 5.99969C8.08122 6.04449 7.97637 6.06845 7.87 6.07Z'
        fill={color ?? 'currentColor'}
      />
      <path
        d='M11.24 8.53C11.0826 8.52813 10.9295 8.47939 10.8 8.39L7.41797 5.92C7.25752 5.80198 7.15052 5.62505 7.12051 5.42814C7.09051 5.23122 7.13995 5.03046 7.25797 4.87C7.376 4.70954 7.55292 4.60254 7.74984 4.57254C7.94675 4.54253 8.14752 4.59198 8.30797 4.71L11.68 7.168C11.7596 7.22627 11.827 7.29971 11.8782 7.3841C11.9294 7.46848 11.9634 7.56216 11.9783 7.65974C11.9931 7.75731 11.9886 7.85687 11.9648 7.95267C11.9411 8.04848 11.8987 8.13865 11.84 8.218C11.7738 8.3158 11.6843 8.39555 11.5795 8.45003C11.4747 8.5045 11.358 8.53199 11.24 8.53Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
);

export const ThumbsUpIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        d='M6.2334 15.292L8.81673 17.292C9.15006 17.6254 9.90006 17.792 10.4001 17.792H13.5667C14.5667 17.792 15.6501 17.042 15.9001 16.042L17.9001 9.95871C18.3167 8.79205 17.5667 7.79205 16.3167 7.79205H12.9834C12.4834 7.79205 12.0667 7.37538 12.1501 6.79205L12.5667 4.12538C12.7334 3.37538 12.2334 2.54205 11.4834 2.29205C10.8167 2.04205 9.9834 2.37538 9.65006 2.87538L6.2334 7.95871'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M1.9834 15.292V7.12533C1.9834 5.95866 2.4834 5.54199 3.65007 5.54199H4.4834C5.65006 5.54199 6.15007 5.95866 6.15007 7.12533V15.292C6.15007 16.4587 5.65006 16.8753 4.4834 16.8753H3.65007C2.4834 16.8753 1.9834 16.4587 1.9834 15.292Z'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
);

export const ThumbsDownIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        d='M13.7665 4.70798L11.1832 2.70798C10.8499 2.37464 10.0999 2.20798 9.59986 2.20798H6.43319C5.43319 2.20798 4.34986 2.95798 4.09986 3.95798L2.09986 10.0413C1.68319 11.208 2.43319 12.208 3.68319 12.208H7.01653C7.51653 12.208 7.93319 12.6246 7.84986 13.208L7.43319 15.8746C7.26653 16.6246 7.76653 17.458 8.51653 17.708C9.18319 17.958 10.0165 17.6246 10.3499 17.1246L13.7665 12.0413'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeMiterlimit='10'
      />
      <path
        d='M18.0166 4.70833V12.875C18.0166 14.0417 17.5166 14.4583 16.35 14.4583H15.5166C14.35 14.4583 13.85 14.0417 13.85 12.875V4.70833C13.85 3.54167 14.35 3.125 15.5166 3.125H16.35C17.5166 3.125 18.0166 3.54167 18.0166 4.70833Z'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
);

export const CopyTextIcon = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    >
      <path
        d='M14.1667 11.1663V13.6663C14.1667 16.9997 12.8334 18.333 9.50008 18.333H6.33341C3.00008 18.333 1.66675 16.9997 1.66675 13.6663V10.4997C1.66675 7.16634 3.00008 5.83301 6.33341 5.83301H8.83341'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.1666 11.1663H11.4999C9.49992 11.1663 8.83325 10.4997 8.83325 8.49967V5.83301L14.1666 11.1663Z'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.66675 1.66699H13.0001'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.83325 4.16699C5.83325 2.78366 6.94992 1.66699 8.33325 1.66699H10.5166'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.3334 6.66699V11.8253C18.3334 13.117 17.2834 14.167 15.9917 14.167'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.3333 6.66699H15.8333C13.9583 6.66699 13.3333 6.04199 13.3333 4.16699V1.66699L18.3333 6.66699Z'
        stroke={color ?? 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
);

export const IconAvatar = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg fill='none' viewBox='0 0 15 15' height={height} width={width} className={className}>
    <path
        fill={color ?? 'currentColor'}
        fillRule='evenodd'
        d='M.877 7.5a6.623 6.623 0 1113.246 0 6.623 6.623 0 01-13.246 0zM7.5 1.827a5.673 5.673 0 00-4.193 9.494A4.971 4.971 0 017.5 9.025c1.762 0 3.31.916 4.193 2.296A5.673 5.673 0 007.5 1.827zm3.482 10.152A4.023 4.023 0 007.5 9.975a4.023 4.023 0 00-3.482 2.004A5.648 5.648 0 007.5 13.173c1.312 0 2.52-.446 3.482-1.194zM5.15 6.505a2.35 2.35 0 114.7 0 2.35 2.35 0 01-4.7 0zm2.35-1.4a1.4 1.4 0 100 2.8 1.4 1.4 0 000-2.8z'
        clipRule='evenodd'
      />
    </svg>
);  

export const googleIcon = (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1_806)'>
      <path
        d='M24.266 12.2764C24.266 11.4607 24.1999 10.6406 24.0588 9.83807H12.74V14.4591H19.2217C18.9528 15.9494 18.0885 17.2678 16.823 18.1056V21.1039H20.69C22.9608 19.0139 24.266 15.9274 24.266 12.2764Z'
        fill='#4285F4'
      />
      <path
        d='M12.74 24.0008C15.9764 24.0008 18.7058 22.9382 20.6944 21.1039L16.8274 18.1055C15.7516 18.8375 14.3626 19.252 12.7444 19.252C9.61376 19.252 6.95934 17.1399 6.00693 14.3003H2.01648V17.3912C4.05359 21.4434 8.20278 24.0008 12.74 24.0008Z'
        fill='#34A853'
      />
      <path
        d='M6.00253 14.3003C5.49987 12.8099 5.49987 11.1961 6.00253 9.70575V6.61481H2.01649C0.31449 10.0056 0.31449 14.0004 2.01649 17.3912L6.00253 14.3003Z'
        fill='#FBBC04'
      />
      <path
        d='M12.74 4.74966C14.4508 4.7232 16.1043 5.36697 17.3433 6.54867L20.7694 3.12262C18.6 1.0855 15.7207 -0.034466 12.74 0.000808666C8.20277 0.000808666 4.05359 2.55822 2.01648 6.61481L6.00252 9.70575C6.95052 6.86173 9.60935 4.74966 12.74 4.74966Z'
        fill='#EA4335'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_806'>
        <rect width='24' height='24' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const IconSave = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    fill={color ?? 'currentColor'}
    viewBox='0 0 16 16'
    height={height}
    width={width}
    className={className}
    >
      <path d='M2 1a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V2a1 1 0 00-1-1H9.5a1 1 0 00-1 1v7.293l2.646-2.647a.5.5 0 01.708.708l-3.5 3.5a.5.5 0 01-.708 0l-3.5-3.5a.5.5 0 11.708-.708L7.5 9.293V2a2 2 0 012-2H14a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h2.5a.5.5 0 010 1H2z' />
    </svg>
);

export const IconArrowBackOutline = ({
  color,
  height = 16,
  width = 16,
}: {
  color?: string;
  height?: number;
  width?: number;
}) => (
  <svg
    viewBox='0 0 512 512'
    fill={color ?? 'currentColor'}
    height={height}
    width={width}
    >
      <path
        fill='none'
        stroke={color ?? 'currentColor'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={48}
        d='M244 400L100 256l144-144M120 256h292'
      />
    </svg>
);

export const IconEye = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    viewBox='0 0 1024 1024'
    fill={color ?? 'currentColor'}
    height={height}
    width={width}
    className={className}
    >
      <path d='M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z' />
    </svg>
);

export const IconEyeInvisible = ({
  color,
  height = 16,
  width = 16,
  className,
}: {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
}) => (
  <svg
    viewBox='0 0 1024 1024'
    fill={color ?? 'currentColor'}
    height={height}
    width={width}
    className={className}
    >
      <path d='M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z' />
      <path d='M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z' />
    </svg>
);

export const microsoftIcon = (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1_810)'>
      <path d='M11.9057 11.4038H0.5V0H11.9057V11.4038Z' fill='#F1511B' />
      <path d='M24.5 11.4038H13.0934V0H24.499V11.4038H24.5Z' fill='#80CC28' />
      <path d='M11.9057 24H0.5V12.5962H11.9057V24Z' fill='#00ADEF' />
      <path d='M24.5 24H13.0934V12.5962H24.499V24H24.5Z' fill='#FBBC09' />
    </g>
    <defs>
      <clipPath id='clip0_1_810'>
        <rect width='24' height='24' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const appleIcon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1_818)'>
      <path
        d='M21.792 18.7036C21.429 19.542 20.9994 20.3139 20.5016 21.0235C19.8231 21.9909 19.2676 22.6605 18.8395 23.0323C18.1758 23.6427 17.4647 23.9552 16.7032 23.973C16.1566 23.973 15.4973 23.8175 14.73 23.5019C13.9601 23.1879 13.2525 23.0323 12.6056 23.0323C11.9271 23.0323 11.1994 23.1879 10.4211 23.5019C9.64153 23.8175 9.01355 23.9819 8.53342 23.9982C7.80322 24.0293 7.07539 23.7078 6.3489 23.0323C5.88521 22.6279 5.30523 21.9346 4.61043 20.9524C3.86498 19.9035 3.25211 18.6873 2.77198 17.3006C2.25777 15.8029 2 14.3526 2 12.9485C2 11.3401 2.34754 9.95285 3.04367 8.79037C3.59076 7.85662 4.31859 7.12005 5.22953 6.57932C6.14046 6.0386 7.12473 5.76305 8.18469 5.74542C8.76467 5.74542 9.52524 5.92483 10.4704 6.27741C11.4129 6.63117 12.0181 6.81058 12.2834 6.81058C12.4817 6.81058 13.154 6.6008 14.2937 6.18259C15.3714 5.79475 16.281 5.63417 17.0262 5.69742C19.0454 5.86038 20.5624 6.65636 21.5712 8.09039C19.7654 9.18458 18.8721 10.7171 18.8898 12.6831C18.9061 14.2145 19.4617 15.4888 20.5535 16.5007C21.0483 16.9703 21.6009 17.3332 22.2156 17.591C22.0823 17.9776 21.9416 18.348 21.792 18.7036ZM17.161 0.480396C17.161 1.68067 16.7225 2.80136 15.8484 3.83866C14.7937 5.07181 13.5179 5.78438 12.1343 5.67194C12.1167 5.52795 12.1065 5.3764 12.1065 5.21714C12.1065 4.06488 12.6081 2.83173 13.4989 1.82347C13.9436 1.31296 14.5092 0.888487 15.1951 0.549875C15.8796 0.216314 16.5269 0.0318484 17.1358 0.000259399C17.1536 0.160717 17.161 0.321185 17.161 0.480381V0.480396Z'
        fill='#1F2A37'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_818'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

// TODO: figure out what to do with houseIcon
export const houseIcon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22 22.75H2C1.80149 22.7487 1.61149 22.6693 1.47112 22.5289C1.33075 22.3885 1.25131 22.1985 1.25 22C1.25131 21.8015 1.33075 21.6115 1.47112 21.4711C1.61149 21.3307 1.80149 21.2513 2 21.25H22C22.1985 21.2513 22.3885 21.3307 22.5289 21.4711C22.6693 21.6115 22.7487 21.8015 22.75 22C22.7487 22.1985 22.6693 22.3885 22.5289 22.5289C22.3885 22.6693 22.1985 22.7487 22 22.75Z'
      fill='#3CCB7F'
    />
    <path
      d='M3.7002 21.9996H2.2002L2.2502 9.96863C2.24969 9.55147 2.345 9.13976 2.52878 8.76526C2.71257 8.39076 2.97991 8.06347 3.3102 7.80863L10.3102 2.35863C10.794 1.98433 11.3885 1.78125 12.0002 1.78125C12.6119 1.78125 13.2063 1.98433 13.6902 2.35863L20.6902 7.79864C21.0183 8.05773 21.2839 8.38728 21.4674 8.7629C21.6508 9.13853 21.7475 9.5506 21.7502 9.96863V21.9986H20.2502V9.98163C20.2488 9.79132 20.2049 9.60373 20.1219 9.43248C20.0389 9.26123 19.9187 9.11063 19.7702 8.99163L12.7702 3.55163C12.5496 3.38151 12.2788 3.28924 12.0002 3.28924C11.7216 3.28924 11.4508 3.38151 11.2302 3.55163L4.2302 9.00163C4.08108 9.11786 3.96037 9.2665 3.87721 9.43629C3.79404 9.60608 3.75061 9.79257 3.7502 9.98163L3.7002 21.9996Z'
      fill='#3CCB7F'
    />
    <path
      d='M14.5 22.75H9.5C9.30149 22.7487 9.11149 22.6693 8.97112 22.5289C8.83075 22.3885 8.75131 22.1985 8.75 22V18.5C8.75079 17.9035 8.9881 17.3317 9.40989 16.9099C9.83167 16.4881 10.4035 16.2508 11 16.25H13C13.5965 16.2508 14.1683 16.4881 14.5901 16.9099C15.0119 17.3317 15.2492 17.9035 15.25 18.5V22C15.2487 22.1985 15.1693 22.3885 15.0289 22.5289C14.8885 22.6693 14.6985 22.7487 14.5 22.75ZM10.25 21.25H13.75V18.5C13.7487 18.3015 13.6693 18.1115 13.5289 17.9711C13.3885 17.8307 13.1985 17.7513 13 17.75H11C10.8015 17.7513 10.6115 17.8307 10.4711 17.9711C10.3307 18.1115 10.2513 18.3015 10.25 18.5V21.25Z'
      fill='#3CCB7F'
    />
    <path
      d='M9.5 14.5H7.5C7.03652 14.4979 6.59262 14.3128 6.26489 13.9851C5.93715 13.6574 5.7521 13.2135 5.75 12.75V11.25C5.7521 10.7865 5.93715 10.3426 6.26489 10.0149C6.59262 9.68715 7.03652 9.5021 7.5 9.5H9.5C9.96348 9.5021 10.4074 9.68715 10.7351 10.0149C11.0628 10.3426 11.2479 10.7865 11.25 11.25V12.75C11.2479 13.2135 11.0628 13.6574 10.7351 13.9851C10.4074 14.3128 9.96348 14.4979 9.5 14.5ZM7.5 11C7.4671 10.9997 7.43447 11.006 7.40401 11.0185C7.37356 11.031 7.3459 11.0494 7.32263 11.0726C7.29936 11.0959 7.28096 11.1236 7.26849 11.154C7.25602 11.1845 7.24973 11.2171 7.25 11.25V12.75C7.24973 12.7829 7.25602 12.8155 7.26849 12.846C7.28096 12.8764 7.29936 12.9041 7.32263 12.9274C7.3459 12.9506 7.37356 12.969 7.40401 12.9815C7.43447 12.994 7.4671 13.0003 7.5 13H9.5C9.5329 13.0003 9.56553 12.994 9.59599 12.9815C9.62644 12.969 9.6541 12.9506 9.67737 12.9274C9.70064 12.9041 9.71904 12.8764 9.73151 12.846C9.74398 12.8155 9.75027 12.7829 9.75 12.75V11.25C9.75027 11.2171 9.74398 11.1845 9.73151 11.154C9.71904 11.1236 9.70064 11.0959 9.67737 11.0726C9.6541 11.0494 9.62644 11.031 9.59599 11.0185C9.56553 11.006 9.5329 10.9997 9.5 11H7.5Z'
      fill='#3CCB7F'
    />
    <path
      d='M16.5 14.5H14.5C14.0365 14.4979 13.5926 14.3128 13.2649 13.9851C12.9372 13.6574 12.7521 13.2135 12.75 12.75V11.25C12.7521 10.7865 12.9372 10.3426 13.2649 10.0149C13.5926 9.68715 14.0365 9.5021 14.5 9.5H16.5C16.9635 9.5021 17.4074 9.68715 17.7351 10.0149C18.0628 10.3426 18.2479 10.7865 18.25 11.25V12.75C18.2479 13.2135 18.0628 13.6574 17.7351 13.9851C17.4074 14.3128 16.9635 14.4979 16.5 14.5ZM14.5 11C14.4671 10.9997 14.4345 11.006 14.404 11.0185C14.3736 11.031 14.3459 11.0494 14.3226 11.0726C14.2994 11.0959 14.281 11.1236 14.2685 11.154C14.256 11.1845 14.2497 11.2171 14.25 11.25V12.75C14.2497 12.7829 14.256 12.8155 14.2685 12.846C14.281 12.8764 14.2994 12.9041 14.3226 12.9274C14.3459 12.9506 14.3736 12.969 14.404 12.9815C14.4345 12.994 14.4671 13.0003 14.5 13H16.5C16.5329 13.0003 16.5655 12.994 16.596 12.9815C16.6264 12.969 16.6541 12.9506 16.6774 12.9274C16.7006 12.9041 16.719 12.8764 16.7315 12.846C16.744 12.8155 16.7503 12.7829 16.75 12.75V11.25C16.7503 11.2171 16.744 11.1845 16.7315 11.154C16.719 11.1236 16.7006 11.0959 16.6774 11.0726C16.6541 11.0494 16.6264 11.031 16.596 11.0185C16.5655 11.006 16.5329 10.9997 16.5 11H14.5Z'
      fill='#3CCB7F'
    />
    <path
      d='M19 7.75001C18.8025 7.75081 18.6128 7.67342 18.4723 7.53475C18.3317 7.39609 18.2518 7.20743 18.25 7.01001L18.23 4.75001H14.58C14.3814 4.7487 14.1914 4.66926 14.0511 4.52889C13.9107 4.38852 13.8313 4.19851 13.83 4.00001C13.8313 3.8015 13.9107 3.61149 14.0511 3.47112C14.1914 3.33075 14.3814 3.25132 14.58 3.25001H18.98C19.1774 3.2492 19.3671 3.32659 19.5076 3.46526C19.6482 3.60392 19.7281 3.79258 19.73 3.99001L19.76 6.99001C19.7584 7.19109 19.6778 7.38348 19.5356 7.52567C19.3934 7.66786 19.201 7.74844 19 7.75001Z'
      fill='#3CCB7F'
    />
  </svg>
);

// TODO: figure out what to do with bookIcon
export const bookIcon = (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.0002 22.0803C11.7036 22.0832 11.4112 22.011 11.1502 21.8703C8.87784 20.7182 6.44324 19.919 3.93017 19.5003L3.64017 19.4603C2.98565 19.3601 2.38734 19.0325 1.95028 18.5351C1.51322 18.0377 1.26535 17.4023 1.25017 16.7403V4.66029C1.24592 4.27984 1.32176 3.90276 1.47277 3.55354C1.62378 3.20433 1.84659 2.8908 2.1267 2.63332C2.40681 2.37584 2.73796 2.18019 3.09863 2.05907C3.45931 1.93794 3.84143 1.89407 4.22017 1.93029C6.8277 2.23561 9.34562 3.06924 11.6202 4.38029L11.8602 4.52029C11.949 4.55828 12.0488 4.56185 12.1402 4.53029L12.3002 4.43029C14.5792 3.11401 17.0987 2.26737 19.7102 1.94029H19.8302C20.201 1.90881 20.5743 1.95576 20.9258 2.07809C21.2772 2.20042 21.599 2.39538 21.8702 2.65029C22.1515 2.90759 22.3754 3.22144 22.527 3.57127C22.6787 3.9211 22.7547 4.29903 22.7502 4.68029V16.7503C22.7362 17.4142 22.4874 18.0517 22.0481 18.5496C21.6087 19.0476 21.0072 19.3737 20.3502 19.4703L20.0202 19.5103C17.5163 19.9277 15.0914 20.727 12.8302 21.8803C12.5759 22.0188 12.2896 22.0878 12.0002 22.0803ZM3.98017 3.41829C3.6697 3.41446 3.3694 3.52886 3.14017 3.73829C3.01475 3.85608 2.91529 3.99874 2.84814 4.15715C2.78099 4.31557 2.74762 4.48625 2.75017 4.65829V16.7383C2.7637 17.0366 2.87781 17.3215 3.07392 17.5466C3.27002 17.7718 3.53657 17.9239 3.83017 17.9783L4.13017 18.0183C6.8106 18.4596 9.40746 19.3095 11.8302 20.5383C11.9149 20.5759 12.0092 20.5864 12.1002 20.5683C14.5278 19.3196 17.1361 18.4591 19.8302 18.0183L20.1702 17.9783C20.4642 17.9255 20.7314 17.7741 20.9277 17.5491C21.1241 17.324 21.2378 17.0387 21.2502 16.7403V4.67029C21.2528 4.49676 21.2195 4.32457 21.1524 4.16453C21.0852 4.00449 20.9858 3.86005 20.8602 3.74029C20.7295 3.62577 20.5773 3.53848 20.4124 3.48353C20.2476 3.42858 20.0734 3.40708 19.9002 3.42029H19.7802C17.4326 3.73338 15.1677 4.4974 13.1102 5.67029L12.9502 5.78029C12.6687 5.94634 12.3483 6.03475 12.0215 6.03651C11.6948 6.03827 11.3734 5.9533 11.0902 5.79029L10.8502 5.65029C8.76653 4.47485 6.4738 3.71672 4.10017 3.41829H3.98017Z'
      fill='#F38744'
    />
    <path
      d='M12 21.2402C11.8015 21.2389 11.6115 21.1595 11.4711 21.0191C11.3307 20.8787 11.2513 20.6887 11.25 20.4902V5.49023C11.2513 5.29173 11.3307 5.10172 11.4711 4.96135C11.6115 4.82098 11.8015 4.74154 12 4.74023C12.1985 4.74154 12.3885 4.82098 12.5289 4.96135C12.6693 5.10172 12.7487 5.29173 12.75 5.49023V20.4902C12.7501 20.5888 12.7308 20.6863 12.6932 20.7774C12.6555 20.8685 12.6003 20.9512 12.5306 21.0209C12.461 21.0905 12.3782 21.1458 12.2872 21.1834C12.1961 21.2211 12.0985 21.2404 12 21.2402Z'
      fill='#F38744'
    />
    <path
      d='M7.75 9.24023H5.5C5.30149 9.23892 5.11149 9.15949 4.97112 9.01912C4.83075 8.87875 4.75131 8.68874 4.75 8.49023C4.75131 8.29173 4.83075 8.10172 4.97112 7.96135C5.11149 7.82098 5.30149 7.74154 5.5 7.74023H7.75C7.94851 7.74154 8.13851 7.82098 8.27888 7.96135C8.41925 8.10172 8.49869 8.29173 8.5 8.49023C8.49869 8.68874 8.41925 8.87875 8.27888 9.01912C8.13851 9.15949 7.94851 9.23892 7.75 9.24023Z'
      fill='#F38744'
    />
    <path
      d='M8.5 12.2402H5.5C5.30149 12.2389 5.11149 12.1595 4.97112 12.0191C4.83075 11.8787 4.75131 11.6887 4.75 11.4902C4.75131 11.2917 4.83075 11.1017 4.97112 10.9614C5.11149 10.821 5.30149 10.7415 5.5 10.7402H8.5C8.69851 10.7415 8.88851 10.821 9.02888 10.9614C9.16925 11.1017 9.24869 11.2917 9.25 11.4902C9.24869 11.6887 9.16925 11.8787 9.02888 12.0191C8.88851 12.1595 8.69851 12.2389 8.5 12.2402Z'
      fill='#F38744'
    />
  </svg>
);
